import { SelectOption } from '@/types/types';
import { DocumentTypeEnum } from '@/types/graphql/schemaTypes';

const seaWaybillOptions: SelectOption<string>[] = [
  { value: 'issue', label: 'Issue' },
  { value: 'draft', label: 'Draft' }
];

const originalBlOptions: SelectOption<string>[] = [
  { value: 'original', label: 'Original' },
  { value: 'draft', label: 'Draft' },
  { value: 'copy', label: 'Copy' },
  { value: 'surrendered', label: 'Surrender' }
];

export function printModeOptions(documentType: string) {
  switch (documentType) {
    case DocumentTypeEnum.sea_waybill:
      return seaWaybillOptions;
    case DocumentTypeEnum.original_bill_of_landing:
      return originalBlOptions;
    default:
      return null;
  }
};
